<script setup lang="ts">
import { onMounted } from 'vue'
import { DefaultLayout } from '@/ui/common/layout'
import { useAppNotification } from '@/composables/use-app-notification'

const { processQueue } = useAppNotification()

onMounted(() => {
  processQueue()
})
</script>

<template>
  <DefaultLayout>
    <RouterView />
  </DefaultLayout>
</template>
